import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  ProductOutlined,
  UserOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { ADMIN, SALESMAN } from "../redux/constants/roles";
import { Link } from "wouter";
import { Typography } from "antd";

const { Text } = Typography;
export const SIDEBAR_ROUTES = {
  [SALESMAN]: [
    {
      key: "heading-orders-1",
      label: <Text className="text-base font-semibold">Order Management</Text>,
      type: "group",
    },
    {
      key: "1",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/order-drafts">Draft Orders</Link>,
    },
    {
      key: "2",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/order-requests">Order Requests</Link>,
    },
    {
      key: "3",
      icon: <CheckCircleOutlined />,
      label: <Link to="/admin/orders">Orders</Link>,
    },
    {
      key: "4",
      icon: <CloseCircleOutlined />,
      label: <Link to="/admin/failed-orders">Failed Orders</Link>,
    },
    {
      key: "heading-orders-2",
      label: (
        <Text className="text-base font-semibold ">Products Management</Text>
      ),
      type: "group",
    },
    {
      key: "5",
      icon: <ProductOutlined />,
      label: <Link to="/admin/products-list">Products</Link>,
    },
    {
      key: "6",
      icon: <DollarCircleOutlined />,
      label: <Link to="/admin/products-pricing">Products Price</Link>,
    },
  ],
  [ADMIN]: [
    {
      key: "7",
      icon: <DashboardOutlined />,
      label: <Link to="/admin/dashboard">Dashboard</Link>,
    },
    {
      key: "heading-orders-1",
      label: <Text className="text-base font-semibold">Order Management</Text>,
      type: "group",
    },
    {
      key: "1",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/order-drafts">Draft Orders</Link>,
    },
    {
      key: "2",
      icon: <ClockCircleOutlined />,
      label: <Link to="/admin/order-requests">Order Requests</Link>,
    },
    {
      key: "3",
      icon: <CheckCircleOutlined />,
      label: <Link to="/admin/orders">Orders</Link>,
    },
    {
      key: "4",
      icon: <CloseCircleOutlined />,
      label: <Link to="/admin/failed-orders">Failed Orders</Link>,
    },
    {
      key: "heading-orders-2",
      label: (
        <Text className="text-base font-semibold ">Products Management</Text>
      ),
      type: "group",
    },
    {
      key: "5",
      icon: <ProductOutlined />,
      label: <Link to="/admin/products-list">Products</Link>,
    },
    {
      key: "6",
      icon: <DollarCircleOutlined />,
      label: <Link to="/admin/products-pricing">Products Price</Link>,
    },
    {
      key: "heading-orders-3",
      label: <Text className="text-base font-semibold ">Users Management</Text>,
      type: "group",
    },
    {
      key: "8",
      icon: <UserOutlined />,
      label: <Link to="/admin/products-list">Dealers</Link>,
    },
    {
      key: "9",
      icon: <TeamOutlined />,
      label: <Link to="/admin/products-pricing">Salesmen</Link>,
    },
  ],
};
